var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgExcelFile = function SvgExcelFile(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00C48C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.081 0l-.848.018H2.165A2.164 2.164 0 0 0 0 2.181v19.655C0 23.032.97 24 2.165 24h13.963a2.164 2.164 0 0 0 2.164-2.164V7.196l.001-.849L12.081 0zm4.287 21.836a.24.24 0 0 1-.24.24H2.165a.24.24 0 0 1-.241-.24V2.18a.24.24 0 0 1 .241-.239h9.068v5.254h5.135v14.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.31 19.267h2.656l-3.492-5.157 2.902-4.288H10.72l-1.574 2.326-1.574-2.326H4.915l2.903 4.288-3.491 5.157h5.771l-.94-1.525H8.015l1.132-1.671z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExcelFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/excelFile.71c3cf71.svg";
export { ForwardRef as ReactComponent };